import React, { useState, useContext, useEffect } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Box,
  Modal,
  Stepper,
  Step,
  StepLabel,
  Button,
  Paper,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useSnackbar } from "notistack";
import { AuthContext } from "../../context/AuthContext";
import ReceiptChange from "./ReceiptsChange";
import ReceiptSelect from "./ReceiptsSelect";
import ReceiptSubmission from "./ReceiptsSubmission";
import { useSelector } from "react-redux";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { font as shabnamFontBinary } from "../../shared/util/functions";
import jMoment from "moment-jalaali";
import { addCommas } from "@persian-tools/persian-tools";

const steps = ["انتخاب کار ها", "اعمال تغییرات", "نهایی سازی"];

const ReceiptsContainer = (props) => {
  const initIndex = useSelector((state) => state.routeReducer.index);
  const [activeStep, setActiveStep] = useState(initIndex);
  const state = useSelector((state) => state.ReceiptReducer);
  const { enqueueSnackbar } = useSnackbar();
  const auth = useContext(AuthContext);

  const prefix = "لابراتوار";
  const handleNext = () => {
    if (activeStep < 2) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      console.log(state);
    }
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  //send receipts data
  const [isLoading, setIsLoading] = useState(false);
  const [receiptCode, setReceiptCode] = useState("");
  const [createReceiptSuccess, setCreateReceiptSuccess] = useState(false);
  const [selectedDoctorName, setSelectedDoctorName] = useState("");

  useEffect(() => {
    console.log(selectedDoctorName);
  }, [selectedDoctorName]);
  let view = null;
  if (activeStep === 0) {
    view = <ReceiptSelect />;
  }
  if (activeStep === 1) {
    view = <ReceiptChange />;
  } else {
    if (activeStep === 2) {
      view = <ReceiptSubmission setDoctorName={setSelectedDoctorName} />;
    }
  }

  async function sendRequest() {
    setIsLoading(true);
    axios
      .post(
        `/api/v1/laboratorys/create-receipts`,
        {
          ...(state.info.laboratoryId && {
            laboratoryId: state.info.laboratoryId,
          }),
          submissionDate: parseInt(new Date(state.info.submitDate).getTime()),
          doctorLabId: state.info.doctorLabId,
          name: state.info.name,
          description: state.info.description ?? "",
          receiptTotal: state.info.endPrice,
          discount: state.info.endDiscount ?? 0,
          cartNumber: state.info.accountNumber,
          receipts: state.orders.map(({ details: attachments, ...rest }) => ({
            attachments: attachments.map(({ discountPrice, _id, ...rest }) => {
              return {
                afterDiscount: discountPrice,
                ...rest,
              };
            }),
            ...rest,
          })),
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        setReceiptCode(response.data.data.receiptCode);
        setCreateReceiptSuccess(true);
        setModalOpen(true);
      })
      .catch((e) => {
        const messages = e.response.data.data;
        Array.isArray(messages)
          ? messages.forEach((message) => {
              enqueueSnackbar(message, { variant: "error" });
            })
          : enqueueSnackbar(messages, { variant: "error" });
      });
    setIsLoading(false);
  }
  const [modalOpen, setModalOpen] = useState(false);
  const onClose = () => {
    setModalOpen(false);
    setActiveStep(initIndex);
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const handlePDFDocCreation = () => {
    const rightMargin = 13.2;
    const leftMargin = 19;
    const topMargin = 25.4;
    const bottomMargin = 36.7;
    const paperWidth = 297;
    const paperHeight = 210;
    const spaceBetweenLines = 15;
    let lastY = topMargin;
    const defaultTextOptions = {
      align: "right",
      maxWidth: paperWidth,
      isSymmetricSwapping: true,
      isInputVisual: true,
      isOutputVisual: false,
    };

    const doc = new jsPDF({
      orientation: "l",
      unit: "mm",
    });
    doc.setFont("Shabnam-FD");

    doc.setFontSize(20);

    doc.text(
      `کد رسید: ${receiptCode}`,
      paperWidth - rightMargin,
      lastY,
      defaultTextOptions
    );
    lastY += spaceBetweenLines;

    doc.setFontSize(16);
    doc.text(
      `اطلاعات فاکتور`,
      paperWidth - rightMargin,
      lastY,
      defaultTextOptions
    );
    lastY += spaceBetweenLines - 10;

    autoTable(doc, {
      startY: lastY,
      head: [
        [
          { content: "شماره کارت", colSpan: 2 },
          { content: "کسب و کار", colSpan: 2 },
        ].reverse(),
      ],
      headStyles: {
        fontStyle: "bold",
        font: "Shabnam-FD",
        halign: "center",
        fillColor: "#000",
      },
      theme: "grid",
      styles: {
        font: "Shabnam-FD",
        halign: "center",
        valign: "middle",
        fontSize: 12,
        lineWidth: 0.75,
      },
      body: [
        [
          {
            content: state.info.accountNumber.split("-").reverse().join("-"),
            colSpan: 2,
          },
          { content: `${prefix} ${auth.name}`, colSpan: 2 },
        ].reverse(),
      ],
    });
    lastY = doc.lastAutoTable.finalY;

    autoTable(doc, {
      startY: lastY,
      head: [
        [
          { content: "به نام", colSpan: 2 },
          { content: "نام پزشک", colSpan: 2 },
          { content: "تاریخ صدور", colSpan: 2 },
        ].reverse(),
      ],
      headStyles: {
        fontStyle: "bold",
        font: "Shabnam-FD",
        halign: "center",
        fillColor: "#000",
      },
      theme: "grid",
      styles: {
        font: "Shabnam-FD",
        halign: "center",
        valign: "middle",
        fontSize: 12,
        lineWidth: 0.75,
      },
      body: [
        [
          { content: state.info.name, colSpan: 2 },
          { content: selectedDoctorName, colSpan: 2 },
          {
            content: jMoment(new Date(state.info.submitDate).getTime()).format(
              "jYYYY/jMM/jDD - hh:mm:ss"
            ),
            colSpan: 2,
          },
        ].reverse(),
      ],
    });
    lastY = doc.lastAutoTable.finalY + spaceBetweenLines + 5;

    doc.setFontSize(16);
    doc.text(
      "جزئیات فاکتور",
      paperWidth - rightMargin,
      lastY,
      defaultTextOptions
    );
    lastY += spaceBetweenLines - 10;

    doc.setFontSize(16);

    let TableBody = [];

    state.orders.forEach((order) => {
      TableBody = TableBody.concat([
        [
          order.orderId,
          order.doctorName,
          order.patientName,
          order.startDate,
          order.endDate,
          order.orderTypeName,
          order.unitCount,
          addCommas(order.totalCost),
        ].reverse(),
      ]);
      if (order.details.length > 0) {
        TableBody = TableBody.concat(
          order.details.map((detail) =>
            [
              `پیوست سفارش ${order.orderId}`,
              "---",
              detail.title,
              "---",
              "---",
              "---",
              detail.count,
              addCommas(detail.discountPrice),
            ].reverse()
          )
        );
      }
    });

    autoTable(doc, {
      startY: lastY,
      head: [
        [
          "شماره سفارش",
          "نام پزشک",
          "نام بیمار / عنوان پیوست",
          "تاریخ شروع",
          "تاریخ پایان",
          "نوع کار",
          "تعداد واحد",
          "مبلغ سفارش",
        ].reverse(),
      ],
      headStyles: {
        fontStyle: "bold",
        font: "Shabnam-FD",
        halign: "center",
        fillColor: "#000",
      },
      theme: "grid",
      styles: {
        font: "Shabnam-FD",
        halign: "center",
        valign: "middle",
        fontSize: 12,
        lineWidth: 0.75,
        overflow: "visible",
      },

      body: TableBody,
    });

    lastY = doc.lastAutoTable.finalY + spaceBetweenLines;

    doc.setFontSize(24);
    doc.text("مجموع", paperWidth - rightMargin, lastY, defaultTextOptions);
    doc.setFontSize(16);

    lastY += spaceBetweenLines - 10;

    const total = state.orders.reduce((prev, current) => {
      let nv = prev + parseInt(current.totalCost);
      if (current.details.length > 0) {
        nv += current.details.reduce((prev, current) => {
          return prev + parseInt(current.discountPrice);
        }, 0);
      }
      return nv;
    }, 0);
    autoTable(doc, {
      startY: lastY,
      head: [
        [
          { id: "col", content: "col" },
          { id: "value", content: "value" },
        ],
      ],
      showHead: false,
      columnStyles: {
        col: {
          fillColor: "#000000",
          textColor: "#FFFFFF",
        },
      },
      styles: {
        font: "Shabnam-FD",
        halign: "center",
        valign: "middle",
        fontSize: 12,
        lineWidth: 0.75,
        overflow: "visible",
      },
      bodyStyles: {
        minCellHeight: 13,
      },
      body: [
        [
          {
            id: "col",
            content: "جمع مبالغ سفارش",
          },
          {
            id: "value",
            content: addCommas(total),
          },
        ].reverse(),
        [
          { id: "col", content: "تخفیف" },
          { id: "value", content: addCommas(state.info.endDiscount) },
        ].reverse(),
        [
          { id: "col", content: "مبلغ نهایی پس از اعمال تخفیف" },
          {
            id: "value",
            content: addCommas(total - state.info.endDiscount),
          },
        ].reverse(),
      ],
    });

    lastY = doc.lastAutoTable.finalY + spaceBetweenLines;

    if (state.info.description) {
      doc.addPage();
      doc.setPage(doc.getCurrentPageInfo().pageNumber);
      lastY = topMargin;

      doc.text("توضیحات", paperWidth - rightMargin, lastY, defaultTextOptions);
      lastY += spaceBetweenLines;
      doc.setFontSize(13);

      doc.text(state.info.description, paperWidth - rightMargin, lastY, {
        ...defaultTextOptions,
        lineHeightFactor: 2,
      });
    }

    doc.output();
    return doc;
  };

  const handlePDFDownload = (doc, _fileName) => {
    const d = new Date();
    // r-c: receipt code
    // t: timestamp
    doc.save(
      _fileName
        ? _fileName
        : `r-c-${receiptCode}-t-${d.getFullYear()}-${d.getMonth()}-${d.getDate()}-${d.getHours()}-${d.getMinutes()}-${d.getSeconds()}`
    );
  };

  return (
    <Paper sx={{ maxWidth: "1200px !important", p: 2 }}>
      <Grid container spacing={2}>
        <Grid xs={12}>
          <Stepper activeStep={activeStep}>
            {steps.map((label, index) => {
              const stepProps = {};
              const labelProps = {};
              return (
                <Step key={`stepper-step-${index + 1}`} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
        </Grid>
        <Grid md={6} xs={12}>
          <Button
            color="secondary"
            variant="outlined"
            disabled={activeStep === 0 || isLoading}
            onClick={handleBack}
            fullWidth
          >
            بازگشت
          </Button>
        </Grid>
        <Grid md={6} xs={12}>
          <Button
            onClick={activeStep === steps.length - 1 ? sendRequest : handleNext}
            color="primary"
            variant="contained"
            fullWidth
            disabled={
              activeStep === steps.length - 1 &&
              (isLoading ||
                !state.info.doctorLabId ||
                state.info.name.length === 0 ||
                state.info.accountNumber.length === 0)
            }
          >
            {activeStep === steps.length - 1 ? "ثبت فاکتور" : "مرحله بعد"}
          </Button>
        </Grid>
        <Grid xs={12}>{view}</Grid>
      </Grid>
      <Modal open={modalOpen} onClose={onClose}>
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            درخواست صدور فاکتور شما با موفقیت ثبت شد.
          </Typography>
          <Grid container spacing={1} sx={{ mt: 2 }}>
            <Grid md={6} xs={12}>
              <Typography
                id="modal-modal-description"
                sx={{ textAlign: "center" }}
              >
                کد رسید شما: {receiptCode}
              </Typography>
            </Grid>
            <Grid md={6} xs={12}>
              <Button
                size="small"
                fullWidth
                variant="contained"
                color="warning"
                onClick={() => handlePDFDownload(handlePDFDocCreation())}
              >
                <PictureAsPdfIcon />
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Paper>
  );
};

export default ReceiptsContainer;

//add font to jspdf class

const font = shabnamFontBinary;

var callAddFont = function () {
  this.addFileToVFS("Shabnam-FD-normal.ttf", font);
  this.addFont("Shabnam-FD-normal.ttf", "Shabnam-FD", "normal");
};
jsPDF.API.events.push(["addFonts", callAddFont]);
